import React from 'react';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let VisualField = props => {
  const { template, previousExams, overviewName, examId, fieldsValues} = props;
  const renderContent = (fieldsValues) => (
    <div className="col-12">
      <div className="row">
        <DisplayField
          isVisible={template.visible}
          value={fieldsValues}
          className="col-12 py-4"
        />
      </div>
    </div>
  )

  return (
    <>
      {fieldsValues && renderContent(fieldsValues)}
      {previousExams?.filter(item => item.id !== examId).map(prevExam =>
        <div className="col-12 border rounded mb-4 px-0">
          <div className="row mx-0">
            <OldValuesHeader prevExam={prevExam} overviewName={overviewName} examId={examId} />
            {renderContent(prevExam?.visual_field)}
          </div>
        </div>
      )}
    </>
  )
}


export default VisualField;